import moment from "moment";
export default function(value) {
	const date = moment(value)
	.locale("en-GB")
	.format("L");
	return date !== "Invalid date" ? date : "N/A";
}
